/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConstantSourcesSinks } from "./ConstantSourcesSinks";
import {
  ConstantSourcesSinksFromJSON,
  ConstantSourcesSinksFromJSONTyped,
  ConstantSourcesSinksToJSON,
  ConstantSourcesSinksToJSONTyped,
} from "./ConstantSourcesSinks";

/**
 *
 * @export
 * @interface PaginatedConstantSourcesSinksList
 */
export interface PaginatedConstantSourcesSinksList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<ConstantSourcesSinks>;
}

/**
 * Check if a given object implements the PaginatedConstantSourcesSinksList interface.
 */
export function instanceOfPaginatedConstantSourcesSinksList(
  value: object
): value is PaginatedConstantSourcesSinksList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedConstantSourcesSinksListFromJSON(
  json: any
): PaginatedConstantSourcesSinksList {
  return PaginatedConstantSourcesSinksListFromJSONTyped(json, false);
}

export function PaginatedConstantSourcesSinksListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedConstantSourcesSinksList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ConstantSourcesSinksFromJSON),
  };
}

export function PaginatedConstantSourcesSinksListToJSON(
  json: any
): PaginatedConstantSourcesSinksList {
  return PaginatedConstantSourcesSinksListToJSONTyped(json, false);
}

export function PaginatedConstantSourcesSinksListToJSONTyped(
  value?: PaginatedConstantSourcesSinksList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ConstantSourcesSinksToJSON),
  };
}
